import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { setAppError } from "../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import nodeinstance from "../../nodeInstance";

export default function UploadFilePopUp_New_Sadaad({
  PopUp,
  setPopUp,
  url,
  title,
  callBack,
  setTrigger,
  trigger,
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState();
  const [error, setError] = useState(false);

  const [iqamma, setIqamma] = useState(false);

  const [errors, setErros] = useState();

  const [absher, setAbsher] = useState(false);

  const [onArrivalMedicalState, setOnArrivalMedical] = useState(false);

  const submitHandler = async (e, fileData, propData) => {
    console.log("fileData......", fileData, file);
    e.preventDefault();

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await nodeinstance.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("response to be printed in the console", response.data);
      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: `${response.data?.data?.totalUpdatedRows} employees updated successfully.`,
            color: "success",
          })
        );
        console.log("response?.data?.errors?.length", response);
        setLoading(false);
        if (response?.data?.data?.errors?.length > 0) {
          setErros(response.data?.data);
          setOnArrivalMedical(true);
          callBack();
          setTrigger(!trigger);
        } else {
          // alert(".....done........");
          setPopUp(false);
          setLoading(false);
          callBack();
          setTrigger(!trigger);
        }
      }
    } catch (err) {
      setError(err);
      setLoading(false);
      console.log("error", err);
    }
  };

  const token = localStorage.getItem("nodeToken");

  console.log("errors..........", errors);
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto rounded-md bg-white/95 flex flex-col p-4 relative">
          {/* Modal Header */}
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          {/* Modal Content */}
          <div className="w-full overflow-y-auto max-h-[70vh]">
            {iqamma ? (
              errors.errors.map((data, ind) => (
                <div key={ind}>
                  {data?.missingFields?.map((New, index) => (
                    <p key={index}>
                      {data?.employeeId} -{" "}
                      <span style={{ color: "red" }}>{New}</span>
                    </p>
                  ))}
                </div>
              ))
            ) : absher ? (
              errors.errors.map((data, index) => (
                <div key={index}>
                  <p key={index}>
                    {data?.employeeId} -{" "}
                    <span style={{ color: "red" }}>{data?.error}</span>
                  </p>
                </div>
              ))
            ) : onArrivalMedicalState ? (
              errors.errors.map((data, index) => (
                <div key={index}>
                  <p key={index}>
                    {data?.employeeId} -{" "}
                    <span style={{ color: "red" }}>{data?.error}</span>
                  </p>
                </div>
              ))
            ) : (
              <form onSubmit={(e) => submitHandler(e, file)} className="w-full">
                <div className="w-full flex flex-col gap-3 my-3 p-5">
                  <div className="form-control w-full ">
                    <label className="label">
                      <span className="label-text">{title}</span>
                    </label>
                    <input
                      type="file"
                      className="file-input file-input-bordered w-full "
                      onChange={(e) => setFile(e.target.files[0])}
                      required
                      accept="application/xls, application/xlsx"
                    />
                  </div>
                  <div
                    className="flex gap-3 w-full justify-center"
                    style={{ margin: 2 }}
                  >
                    <button
                      type="submit"
                      className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm" // Decreased padding and font size
                    >
                      <p>Submit</p>
                      {loading ? <CgSpinner className="animate-spin" /> : ""}
                    </button>
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
